import { styled, Box } from '@withjoy/joykit';

export const StyledQuickAddFormBox = styled(Box)`
  padding-left: 36px;
  padding-right: 36px;
  padding-bottom: 36px;
  padding-top: 0;

  & {
    display: none;
  }
`;
